import React from 'react';
import { Badge } from 'react-bootstrap';

const StatementTabSwitcher = ({
  activeTab,
  onTabChange,
  unpaidCount,
  pendingReconciliationCount,
  rightAction = null
}) => {
  const tabs = [
    { id: 'statement', label: 'Statement', badge: unpaidCount, badgeColor: '#DBEAFE', textColor: '#1E40AF' },
    {
      id: 'reconciliation',
      label: 'Reconciliation',
      badge: pendingReconciliationCount,
      badgeColor: '#CFFAFE',
      textColor: '#0F766E'
    }
  ];

  const getTabStyle = (isActive) => ({
    height: 'auto',
    border: 'none',
    borderBottom: `3px solid ${isActive ? 'var(--dark)' : 'transparent'}`,
    color: isActive ? 'var(--dark)' : 'var(--soft-grey)',
    fontWeight: isActive ? 600 : 500
  });

  return (
    <div className="border-bottom mb-3">
      <div className="d-flex align-items-center justify-content-between">
        <div className="d-flex" style={{ gap: 8 }}>
          {tabs.map(tab => (
            <button
              key={tab.id}
              type="button"
              onClick={() => onTabChange(tab.id)}
              onMouseEnter={e => {
                if (activeTab !== tab.id) e.currentTarget.style.color = '#212529';
              }}
              onMouseLeave={e => {
                if (activeTab !== tab.id) e.currentTarget.style.color = '#6c757d';
              }}
              className="d-flex align-items-center rounded-0 bg-transparent mb-0 p-2 midFont shadow-0 cursor-pointer focus-none"
              style={getTabStyle(activeTab === tab.id)}
            >
              {tab.label}
              <Badge className={`ml-2`} style={{ backgroundColor: tab.badgeColor, color: tab.textColor }}>{tab.badge}</Badge>
            </button>
          ))}
        </div>
        {rightAction ? <div className="ml-3 mb-1 flex-shrink-0">{rightAction}</div> : null}
      </div>
    </div>
  );
};

export default StatementTabSwitcher;
